<template>
    <v-container>
      <v-container class="pa-0" fluid>
        <template v-if="!feedbackSent">
          <v-row justify="center">
            <div class="pa-3 pt-0">
              <v-img max-height="180" contain src="/static/images/omaok-feedback.png" />
            </div>
          </v-row>
          <v-row justify="center" v-if="$vuetify.breakpoint.mdAndUp">
            <div class="pa-3">
              <h2 class="mt-0 mb-0 text-h2">{{ $t('feedback-header') }}</h2>
            </div>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="10">
              <v-row justify="center">
                <div class="pa-3 text-h5">
                  {{ $t('feedback-text-1') }}
                </div>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" sm="9">
                  <v-slider class="feedback-slider"
                            v-model="nps"
                            min="0"
                            max="10"
                            ticks
                            tick-size="0"
                            :tick-labels="tickLabels"
                            track-color="#F7F8FA"
                            track-fill-color="#F7F8FA" />
                  <v-row justify="space-between">
                    <div :class="{ 'pa-3 pt-0 text-h6': $vuetify.breakpoint.mdAndUp, 'pa-3 pt-0': $vuetify.breakpoint.smAndDown }">{{ $t('feedback-text-2') }}</div>
                    <div :class="{ 'pa-3 pt-0 text-h6': $vuetify.breakpoint.mdAndUp, 'pa-3 pt-0': $vuetify.breakpoint.smAndDown }">{{ $t('feedback-text-3') }}</div>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row justify="center">
            <div class="pa-3 text-h5">
              {{ $t('feedback-text-4') }}
            </div>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="9">
              <v-textarea v-model="comment"
                          outlined
                          auto-grow
                          :counter="300"
                          maxlength="300">
              </v-textarea>
            </v-col>
          </v-row>
          <v-row justify="center">
            <div class="pa-3 pt-0">
              <v-btn tile class="primary wide-button" @click="sendGeneralFeedback" :disabled="loading" :loading="loading">
                {{ $t('feedback-send') }}
              </v-btn>
            </div>
          </v-row>
          <v-row justify="center">
            <div class="pa-3">
              <p class="mb-0">{{ $t('feedback-text-5') }}</p>
              <span class="mr-1">{{ $t('feedback-text-5-1') }}</span>
              <router-link to="/help#CustomerSupport" class="text-decoration-none">
                <a class="font-weight-bold" @click="$emit('close')">{{ $t('feedback-text-5-2') }}</a>
              </router-link>
            </div>
          </v-row>
        </template>
        <template v-else>
          <v-row justify="center">
            <div class="pa-3">
              <v-icon :size="100" color="color-green">
                fa-check
              </v-icon>
            </div>
          </v-row>
          <v-row justify="center">
            <div class="pa-3 text-h5">
              {{ $t('feedback-text-6') }}
            </div>
          </v-row>
          <v-row justify="center">
            <div class="pa-3">
              <v-btn tile outlined dark color="color-new-link-blue" class="wide-button" @click="$emit('close')">
                <span>{{ $t('close') }}</span>
              </v-btn>
            </div>
          </v-row>
        </template>
      </v-container>
    </v-container>
</template>

<script>
  import { apiResource } from '@/util/resources'

  export default {
    data: function () {
      return {
        nps: 5,
        comment: '',
        feedbackSent: false
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      tickLabels () {
        return ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
      }
    },
    methods: {
      sendGeneralFeedback () {
        this.$store.commit('setLoading', true)

        var data = {
          FeedbackType: 1,
          OrderNr: 0,
          Comment: this.comment,
          Smiley: null,
          NPS: this.nps
        }

        apiResource.post('api/feedback/save', data).then((response) => {
          this.$store.commit('setLoading', false)

          if (response.data.status === 0) {
            if (response.data.responseObject != null) {
              this.feedbackSent = true
              this.$matomo && this.$matomo.trackEvent("Feedback", "General", "Feedback Sent")
            } else {
              this.$store.commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
              this.$matomo && this.$matomo.trackEvent("Feedback", "General", "Feedback Failed")
            }
          } else {
            this.$store.commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
            this.$matomo && this.$matomo.trackEvent("Feedback", "General", "Feedback Failed")
          }
        }).catch((errorResponse) => {
          this.$store.commit('setLoading', false)
          this.$store.commit('setMessage', { type: 'error', text: 'error.generic.0', translate: true })
          this.$matomo && this.$matomo.trackEvent("Feedback", "General", "Feedback Failed")
        })
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "feedback-header": "Anna palautetta",
  "feedback-text-1": "Asiointi Oma B2 Impact -palvelussa sujui hyvin",
  "feedback-text-2": "Täysin eri mieltä",
  "feedback-text-3": "Täysin samaa mieltä",
  "feedback-text-4": "Avoin palaute Oma B2 Impact -palvelusta",
  "feedback-text-5": "Palautelomakkeen kautta lähetetyt viestit tallennetaan ilman henkilötietoja, joten emme voi vastata niihin.",
  "feedback-text-5-1": "Jos sinulla on kysyttävää velka-asioihin tai maksamiseen liittyen, otathan yhteyttä suoraan",
  "feedback-text-5-2": "asiakaspalveluumme",
  "feedback-text-6": "Kiitos palautteestasi!",
  "feedback-send": "Lähetä palaute"
  },
  "se": {
  "feedback-header": "Ge respons",
  "feedback-text-1": "Mitt besök i Min B2 Impact -tjänsten lyckades bra",
  "feedback-text-2": "Helt av annan åsikt",
  "feedback-text-3": "Helt av samma åsikt",
  "feedback-text-4": "Öppen respons om Min B2 Impact -tjänsten",
  "feedback-text-5": "Meddelanden som skickas via responsblanketten sparas utan personuppgifter, vilket betyder att vi inte kan svara på dem.",
  "feedback-text-5-1": "Har du frågor gällande fordringar eller betalningar, vänligen kontakta vår",
  "feedback-text-5-2": "kundtjänst",
  "feedback-text-6": "Tack för din respons!",
  "feedback-send": "Skicka respons"
  },
  "en": {
  "feedback-header": "Leave feedback",
  "feedback-text-1": "My visit in My B2 Impact -service went well",
  "feedback-text-2": "Disagree",
  "feedback-text-3": "Agree",
  "feedback-text-4": "General feedback about My B2 Impact-service",
  "feedback-text-5": "Messages sent via this form are saved without personal information, which means we cannot reply to you.",
  "feedback-text-5-1": "If you have any questions about managing your debts or payments, please contact our",
  "feedback-text-5-2": "customer service",
  "feedback-text-6": "Thank you for your feedback!",
  "feedback-send": "Send feedback"
  }
  }
</i18n>

<style>
  .feedback-slider .v-slider__thumb {
    width: 24px;
    height: 24px;
    left: -13px;
  }

  .feedback-slider .v-slider__thumb:before {
    top: -6px;
    left: -6px;
  }

  .feedback-slider .v-slider--horizontal .v-slider__ticks-container {
    color: #A2ADB8;
    font-weight: bold;
  }

  .feedback-slider .v-slider--horizontal .v-slider__track-container {
    height: 6px;
  }

  @media (min-width: 768px) {
    .feedback-slider .v-slider--horizontal .v-slider__ticks-container {
      font-size: 1.25rem;
    }
  }
</style>
